import type { IntlConfig } from "next-intl";
import { IntlErrorCode } from "next-intl";

import { consoleErrorPackagesi18n } from "./consoleErrorPackagesi18n";
import type { DeepMergeMessagesProps } from "./deepMergeMessages";
import { deepMergeMessages } from "./deepMergeMessages";

export type Basei18nProps = DeepMergeMessagesProps & {
  requestConfig?: Omit<IntlConfig, "locale">;
};

export const basei18n = ({
  defaultMessages,
  requestConfig,
  userMessages,
}: Basei18nProps): Omit<IntlConfig, "locale"> => ({
  getMessageFallback({ namespace, key, error }) {
    const message = [namespace, key].filter((part) => part != null).join(".");
    if (error.code === IntlErrorCode.MISSING_MESSAGE)
      return `${message}: message not translated`;
    else {
      consoleErrorPackagesi18n({
        heading: `${message} (${error.code})`,
        error: error.message,
      });
      return `${message} (${error.code}): ${error.message}`;
    }
  },
  messages: deepMergeMessages({ defaultMessages, userMessages }),
  onError(error) {
    if (error.code === IntlErrorCode.MISSING_MESSAGE)
      consoleErrorPackagesi18n({ heading: error.code, error: error.message });
    else throw error;
  },
  timeZone: "UTC",
  ...requestConfig,
});
